<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <label>جستجو</label>
                        <input type="text" class="form-control" v-model="searchInput" @keyup="search">
                    </div>
                </div>
            </div>
            <div class="table-responsive" v-if="people.length">
                <table class="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th class="text-center">ردیف</th>
                            <th class="text-center">نام</th>
                            <th class="text-center">نام خانوادگی</th>
                            <th class="text-center">شماره کارت</th>
                            <th class="text-center">شماره همراه</th>
                            <th class="text-center">کد ملی</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(person,index) in people" :key="index">
                            <td class="text-center">{{ index + 1 }}</td>
                            <td class="text-center">{{ person.firstName }}</td>
                            <td class="text-center">{{ person.lastName }}</td>
                            <td class="text-center">{{ person.pan }}</td>
                            <td class="text-center">{{ person.mobile }}</td>
                            <td class="text-center">{{ person.passportNo }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="alert alert-info mb-0" v-else>
                <p class="mb-0">شخصی یافت نشد</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Tourists',
    data(){
        return {
            allPeople: [],
            people: [],
            searchInput: '',
            showLoading: true,
        }
    },
    methods: {
        getData(){
            this.$api.get('Organizations/Tourists').then(({data}) => {
                if(data.status){
                    this.allPeople = data.result;
                    this.people = data.result;
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        search(){
            this.people = this.allPeople.filter(person => (person.firstName + ' ' + person.lastName).includes(this.searchInput) || person.pan.includes(this.searchInput) || person.mobile.includes(this.searchInput) || person.passportNo.includes(this.searchInput));
        }
    },
    created(){
        this.getData();
    }
}
</script>